import { ImportantDevices } from '@material-ui/icons';
import axios from 'axios'
import { ApiResponse, handleApiErrors } from '..';
import { DeviceLogData, DeviceOverview, LocationOverviewData, SearchList, SearchListParams, DeviceOverviewParams, DeviceManageParams, DeviceLogParams, CheckoutParams, DeviceMangeResult, CheckoutResult } from './models';
import {ParamsXlsx,ExportXlsxData} from '../statistics/models'


const baseUrl = () => {
    return `${process.env.REACT_APP_MOBILBASE_API}`;
}

const recieptUrl = () => {
    return `${process.env.REACT_APP_RECIEPT}`;
}

export async function getLocationOverview(): Promise<ApiResponse<LocationOverviewData[]>> {
    return axios.get<LocationOverviewData[]>(
        `${baseUrl()}/locations`
    ).then(res => {return {data: res.data, errorStatus: undefined, errorMessage: undefined}})
    .catch((e) => handleApiErrors<LocationOverviewData[]>(e));
}

export async function getDeviceOverview(params: DeviceOverviewParams): Promise<ApiResponse<DeviceOverview>> {
    return axios.get<DeviceOverview>(
        `${baseUrl()}/location/${params.locationId}/devices`
    ).then(res => {return {data: res.data, errorStatus: undefined, errorMessage: undefined}})
    .catch((e) => handleApiErrors<DeviceOverview>(e));
}

export async function getDeviceLog(params: DeviceLogParams): Promise<ApiResponse<DeviceLogData>> {
    return axios.get<DeviceLogData>(
        `${baseUrl()}/location/${params.locationId}/device/${params.deviceId}/log`
    ).then(res => {return {data: res.data, errorStatus: undefined, errorMessage: undefined}})
    .catch((e) => handleApiErrors<DeviceLogData>(e));
}

export async function searchLocation(params: SearchListParams): Promise<ApiResponse<SearchList>> {
    return axios.post<SearchList>(
        `${baseUrl()}/location/${params.locationId}/search`,
        { ...params.body }
    ).then(res => {return {data: res.data, errorStatus: undefined, errorMessage: undefined}})
    .catch((e) => handleApiErrors<SearchList>(e));
}

export async function postManageDevice(params: DeviceManageParams): Promise<ApiResponse<DeviceMangeResult>> {
    return axios.post<DeviceMangeResult>(
        `${baseUrl()}/location/${params.locationId}/device/${params.deviceId}/manage`,
        { ...params.body }
    ).then(res => {return {data: res.data, errorStatus: undefined, errorMessage: undefined}})
    .catch((e) => handleApiErrors<DeviceMangeResult>(e));
}

export async function postCheckout(params: CheckoutParams): Promise<ApiResponse<CheckoutResult>> {
    return axios.post<CheckoutResult>(
        `${baseUrl()}/location/${params.locationId}/device/${params.deviceId}/checkout`,
        { ...params.body }
    ).then(res => {return {data: res.data, errorStatus: undefined, errorMessage: undefined}})
    .catch((e) => handleApiErrors<CheckoutResult>(e));
}

export async function requestPDF(locationId: number, id: number, payType: string): Promise<ApiResponse<Blob>> {
/*     return axios.get<Blob>(`${baseUrl()}/api/v1/receipt/${payType}/${locationId}/${id}`, {responseType: 'blob'})
        .then(res => {return {data: new Blob([res.data]), errorStatus: undefined, errorMessage: undefined}})
        .catch((e) => handleApiErrors<Blob>(e)); */
        return axios.get<Blob>(`${recieptUrl()}/${locationId}/${payType}/${id}`, {responseType: 'blob'})
        .then(res => {return {data: new Blob([res.data]), errorStatus: undefined, errorMessage: undefined}})
        .catch((e) => handleApiErrors<Blob>(e));        
}

export async function requestXlsx(filename: string, apiFunc: string,param: ParamsXlsx) {
    return axios.post(`${baseUrl()}/export/${apiFunc}/${param.location}`, 
        {
            ...param.body,
 })
 .then((response) =>{
    console.log(response.data);
    const  xlsxData: ExportXlsxData =response.data as ExportXlsxData
    console.log('xlsxData.fileName '+xlsxData.fileName);
    console.log('xlsxData.data.byteLength '+xlsxData.data.length);
    console.log('xlsxData.data '+xlsxData.data);
    const buffer = Buffer.from(xlsxData.data,'base64');
    console.log('buffer '+buffer.byteLength);
    const url = window.URL.createObjectURL(new Blob([buffer]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', xlsxData.fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();

 })
 


 //}

 /*
.then((response) => {

    const url = window.URL.createObjectURL(new Blob([atob((ExportXlsxData)response.data)]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename+`${Date.now()}.xlsx`);
    document.body.appendChild(link);
    link.click();
    
})
*/
;
}

export async function requestXlsxBlop(filename: string, apiFunc: string,param: ParamsXlsx){

    
    return axios.post(`${baseUrl()}/export/${apiFunc}/${param.location}`, 
        {
            ...param.body,
        }, {responseType: 'blob'})
        .then((response) => {

//            console.log('response.headers');
//    console.log(response.headers['content-disposition']);

    
    
    const blob=new Blob([response.data]);
  //  console.log('blob.size '+blob.size);
    

    const cd = response.headers['content-disposition'];
//    console.log( cd);

//    console.log('filename');
    const filename = cd.split('filename=')[1].split(';')[0];
    
//    console.log(filename);
    
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
            
    })
/*     .catch((E)=>{
        console.log(E);
        handleApiErrors(E);
    })
 */    ;
}
